var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolarPower({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24L2.398438 12L21.601562 12L24 24ZM1.199219 2.398438L1.199219 0L4.800781 0L4.800781 2.398438ZM2.941406 21.601562L10.800781 21.601562L10.800781 19.199219L3.421875 19.199219ZM4.949219 8.789062L3.238281 7.109375L5.789062 4.558594L7.5 6.238281ZM3.898438 16.800781L10.800781 16.800781L10.800781 14.398438L4.378906 14.398438ZM7.753906 4.246094 C 6.585938 3.074219 6 1.660156 6 0L8.398438 0 C 8.398438 1 8.75 1.851562 9.449219 2.550781 C 10.148438 3.25 11 3.601562 12 3.601562 C 13 3.601562 13.851562 3.25 14.550781 2.550781 C 15.25 1.851562 15.601562 1 15.601562 0L18 0 C 18 1.660156 17.414062 3.074219 16.246094 4.246094 C 15.074219 5.414062 13.660156 6 12 6 C 10.339844 6 8.925781 5.414062 7.753906 4.246094ZM10.800781 10.800781L10.800781 7.199219L13.199219 7.199219L13.199219 10.800781ZM13.199219 21.601562L21.058594 21.601562L20.578125 19.199219L13.199219 19.199219ZM13.199219 16.800781L20.101562 16.800781L19.621094 14.398438L13.199219 14.398438ZM19.050781 8.789062L16.53125 6.238281L18.210938 4.558594L20.761719 7.078125ZM19.199219 2.398438L19.199219 0L22.800781 0L22.800781 2.398438ZM19.199219 2.398438",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarPower);
export default __webpack_public_path__ + "static/media/solar_power.1d3a2e047425a1d64d49196b06d6c4a8.svg";
export { ForwardRef as ReactComponent };